<template>
    <div class="global-navigation">
        <div v-for="question of props.questions" :key="question.id" class="navigation-item">
            <button
                :class="{ current: currentQuestionId === question.id, done: isDone(question) }"
                class="app-btn"
                @click="navigateToQuestion(question.id)"
            >
                {{ question.id}}
            </button>
        </div>
    </div>
</template>

<script setup>
import { LocalStorageService } from '@/services/LocalStorageService';
import { defineProps, defineEmits } from 'vue';

const localStorageService = new LocalStorageService();

const props = defineProps(['questions', 'currentQuestionId']);

const emit = defineEmits(['navigation-change']);

const isDone = question => {
    const questionState = localStorageService.getQuestionState(question?.id);

    return localStorageService.questionAnswered(questionState);    
};

const navigateToQuestion = questionid => {
    emit('navigation-change', questionid);
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
.global-navigation {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;
    padding: 0 5%;

    button {
        margin: 10px 5px;
        padding: 5px;
        width: 40px;
        height: 40px;
        box-sizing: border-box;

        &.current {
            border-width: 5px;
        }

        &.done {
            background-color: $tetriary-color;
            color: $secondary-color;
            border-color: $tetriary-color;

            &.current {
                background-color: $secondary-color;
                color: $primary-color;
            }

            &:hover {
                background-color: $secondary-color;
                color: $primary-color;
            }
        }
    }
}
</style>
